export default {
  slug: "jetbrains-academy",
  code: "EDU",
  label: "JetBrains Academy",
  shortLabel: "Academy",
  hideProductName: true,
  krakenDir: "JetBrains Academy",
  logoFamily: "academy",
};
